import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import { SlotList } from '../index'

const template = {
  UNIT_MAPPING: {
    DOM: {
      DESKTOP: {},
      MOBILE: {}
    },
    INTL: {
      DESKTOP: {},
      MOBILE: {}
    }
  }
}

export const Sharethrough = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  VENDOR.SHARETHROUGH = { ...template, ...VENDOR.SHARETHROUGH }
  const { SHARETHROUGH } = VENDOR
  const { UNIT_MAPPING } = SHARETHROUGH
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  const displayUnitMappingTable = () => {
    return (
      <Table size='small' aria-label='SHARETHROUGH-unit-mapping-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6'>Unit Mapping</Typography></TableCell>
            <TableCell>Domestic</TableCell>
            <TableCell>International</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Desktop</TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='SHARETHROUGH.UNIT_MAPPING.DOM.DESKTOP'
                object={UNIT_MAPPING.DOM.DESKTOP}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='SHARETHROUGH.UNIT_MAPPING.INTL.DESKTOP'
                object={UNIT_MAPPING.INTL.DESKTOP}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Mobile</TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='SHARETHROUGH.UNIT_MAPPING.DOM.MOBILE'
                object={UNIT_MAPPING.DOM.MOBILE}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top' }}>
              <SlotList
                path='SHARETHROUGH.UNIT_MAPPING.INTL.MOBILE'
                object={UNIT_MAPPING.INTL.MOBILE}
                options={options}
                allOptions={allOptions}
                setOptions={setOptions}
                setAllOptions={setAllOptions}
                errors={errors}
                setErrors={setErrors}
                validation={validation}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='Sharethrough-panel-content'
        id='Sharethrough-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Sharethrough</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>{displayUnitMappingTable()}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
